/**
 * This service serves as an interface how a real BookmarkService should be implemented! Do not use in Production!
 */
angular.module('IndicatorSearch').factory('SearchTrackingService', function($http, $httpParamSerializerJQLike){
  'use strict';

  var rootUri = '/de/api-search/';
  var ajaxTargetPid = 0;
  return {
    writeLog: function (trackingId, title, theme, metaTags) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[log]': {
            title: title,
            theme: theme,
            trackingId: trackingId,
            metaTags: metaTags
          }
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        });
    }
  };
});
